var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"alert-general"}},[_c('b-alert',{staticClass:"mt-3",attrs:{"show":"","variant":_vm.variant}},[_c('div',{staticClass:"text-alert-modal",attrs:{"v-if":_vm.icon}},[_c('img',{staticClass:"img-alert-modal mr-2 mb-1",attrs:{"src":require("@/assets/images/icons/warning_.svg"),"width":"15%"}}),_vm._v(" "+_vm._s(_vm.text)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }